/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

import './index.css';

const Button = ({ className, children, ...props }) => (
  <button {...props} className={`Button ${className}`.trim()}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

Button.defaultProps = {
  children: <span>&nbsp;</span>,
  className: '',
  type: 'button',
  onClick: noop,
};

export default Button;
